import { AccountCircleOutlineIcon } from './AccountCircleOutlineIcon';

/**
 * author: Google
 * id 17CE7627-5016-43F9-B42D-AFAAFA0A0564
 * name account-circle-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-circle-outline.svg
 * tags
 * - Account / User 
 */
export const UserCircleOutlineIcon = AccountCircleOutlineIcon;
export default UserCircleOutlineIcon